module.exports = __webpack_public_path__ + "media/images/lp_modal-image_original_service-b1a968d14a8dd1823ddaeaf90f4b217b.webp";